import {createAction} from 'redux-actions';
import {batchActions} from "redux-batched-actions";
import {ISticker} from "./reducer";
import {AnyAction} from "redux";
import stickerRepository from "../../../domain/repositories/StickerRepository";
import Noty from "noty";
const namespace = 'STICKER_ENTITIES';

export const stickerLoadRequest: (data: { stickerId: string }) => AnyAction
    = createAction(`${namespace}/STICKER_LOAD_REQUEST`);
export const stickerLoadSuccess: (data: { stickerId: string, sticker: ISticker }) => AnyAction
    = createAction(`${namespace}/STICKER_LOAD_SUCCESS`);
export const stickerLoadFailed: (data: { stickerId: string, error: Error }) => AnyAction
    = createAction(`${namespace}/STICKER_LOAD_FAILED`);

export function loadSticker(stickerId: string, options = {scanEvent: false}) {
    return (dispatch, getState) => {
        if (!stickerId) {
            return;
        }

        dispatch(stickerLoadRequest({stickerId}));
        const state: { password?: string } = {}; // TODO: handle password
        const requestParams = (state.password ? {password: state.password} : {}) as any;
        if (options.scanEvent) {
            requestParams.source = 'web';
        }
        stickerRepository.loadById(stickerId, requestParams)
            .then((response) => response.data)
            .then((sticker: ISticker) => {
                dispatch(stickerLoadSuccess({stickerId, sticker}))
            })
            .catch((error) => {
                const actions = [stickerLoadFailed({stickerId, error})];
                // switch (error.code) {
                //     // Show password error
                //     case StickerLoadErrorCodeEnum.PasswordNotCorrect:
                //         actions.push(setFormErrors({password: error.code}));
                //         break;
                //     case StickerLoadErrorCodeEnum.StickerNotFound:
                //         actions.push(setFormErrors({notFound: true}));
                //         if (getState().router.location.pathname !== '/scan-sticker') {
                //             actions.push(replace('/'))
                //         }
                //         break;
                //     // Show password modal
                //     case StickerLoadErrorCodeEnum.PasswordRequired:
                //         actions.push(setPasswordModalVisibility(true));
                //         break;
                //     default:
                //         actions.push(setFormErrors({server: true}));
                //         break;
                // }
                dispatch(batchActions(actions));
            });
    };
}

export function cleanSticker(stickerId?: string | null) {
    return (dispatch) => {
        if (!stickerId) {
            return
        }

        return stickerRepository
            .cleanSticker(stickerId)
            .catch((error) => {
                new Noty({
                    type: 'error',
                    timeout: 3000,
                    text: `Failed cleaning sticker. ${error?.message || error}`,
                }).show();
                throw error;
            });
    };
}
